<div class="app-wrapper">
  <header class="fixed-top top1">
    <div class="container-fluid topbg ">
      <div class="row align-items-center flex-wrap text-white px-3 px-md-4">
        <!-- Left: Contact Info -->
        <div
          class="col-6 col-md-6 mb-2 mb-md-0 d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3">
          <div><i class="bi bi-whatsapp"></i> +254 203318581</div>
          <div><i class="bi bi-envelope"></i> info@kemis.go.ke</div>
        </div>

        <!-- Right: Search, Login, Social -->
        <div
          class="col-6 col-md-6 d-flex justify-content-start justify-content-md-end align-items-center flex-wrap gap-3">
          <button class="login-btn" (click)="GoToLogin()">Login</button>

          <div class="social-icons d-flex justify-content-between gap-2">
            <a href="#"><i class="bi bi-facebook"></i></a>
            <a href="#"><i class="bi bi-youtube"></i></a>
            <a href="#"><i class="bi bi-linkedin"></i></a>
          </div>
        </div>
      </div>
    </div>

    <nav class="navbar navbar-expand-lg py-2" style="background-color: #fff !important;">
      <div class="container-fluid px-xl-4 d-flex align-items-center justify-content-between flex-wrap">
        <!-- Left Logo -->
        <a class="navbar-brand d-flex align-items-center order-2 order-lg-0" href="#" (click)="isShow=true">
          <img src="../../../assets/images/landing_imgs/Ministry-of-Kenya-Logo.png" alt="Left Logo"
            class="logo-img me-xl-2" />
        </a>

        <!-- Mobile Toggle Button -->
        <button class="navbar-toggler p-2" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavbar"
          aria-controls="mainNavbar" aria-expanded="false" aria-label="Toggle navigation">
          <!-- <span class="navbar-toggler-icon"></span> -->
          <i class="bi bi-list"></i>
        </button>

        <!-- Nav Items -->
        <div class="collapse navbar-collapse justify-content-center" id="mainNavbar">
          <ul class="navbar-nav mx-auto justify-content-center w-100">
            <li class="nav-item">
              <a class="nav-link nav-home" href="#" (click)="isShow=true">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link nav-about" href="#about-kemis" (click)="isShow=true">About KEMIS</a>
            </li>
            <li class="nav-item">
              <a class="nav-link nav-modules" href="#system-module" (click)="isShow=true">System Modules</a>
            </li>
            <!-- <li class="nav-item">
            <a class="nav-link nav-edulocker" href="#">EduLocker</a>
          </li> -->
            <!-- <li class="nav-item">
            <a class="nav-link nav-stakeholder" href="#">Stakeholder Portals</a>
          </li> -->
            <li class="nav-item">
              <a class="nav-link nav-resources" (click)="isShow=false">Resources</a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-dark" href="#support" (click)="isShow=true">Support</a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-dark" href="#faqs" (click)="isShow=true">FAQ's</a>
            </li>
          </ul>
        </div>

        <!-- Right Logo -->
        <div class="d-lg-block order--2">
          <img src="../../../assets/images/landing_imgs/Kemis-Logo.png" alt="Right Logo" class="logo-img" />
        </div>
      </div>
    </nav>
  </header>


  <div class="main-section" id="content">
    <section *ngIf="isShow">
      <div class="container-fluid">
        <div class="row g-0 align-items-stretch">
          <div class="col-xl-2 p-0 d-none d-sm-none d-lg-block">
            <!-- Add Swiper HTML structure -->
            <div class="swiper category-vertical-carousel" #swiperContainer>
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_1.png" class="img-fluid w-100" alt="Slide 1" />
                </div>
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_2.png" class="img-fluid w-100" alt="Slide 2" />
                </div>
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_3.png" class="img-fluid w-100" alt="Slide 3" />
                </div>
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_1.png" class="img-fluid w-100" alt="Slide 4" />
                </div>
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_2.png" class="img-fluid w-100" alt="Slide 5" />
                </div>
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_3.png" class="img-fluid w-100" alt="Slide 6" />
                </div>
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_1.png" class="img-fluid w-100" alt="Slide 7" />
                </div>
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_2.png" class="img-fluid w-100" alt="Slide 8" />
                </div>
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_3.png" class="img-fluid w-100" alt="Slide 3" />
                </div>
              </div>

              <!-- Optional pagination -->
              <!-- <div class="swiper-pagination"></div> -->
            </div>
          </div>
          <!-- <div class="row d-md-none d-sm-block"> -->
          <div class="col-xl-12 p-0 d-md-none d-sm-block">
            <!-- Add Swiper HTML structure -->
            <div class="swiper category-horizontal-carousel">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_1.png" class="img-fluid w-100" alt="Slide 1" />
                </div>
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_2.png" class="img-fluid w-100" alt="Slide 2" />
                </div>
                <div class="swiper-slide">
                  <img src="assets/images/landing_imgs/slider_3.png" class="img-fluid w-100" alt="Slide 3" />
                </div>
              </div>
            </div>

            <!-- Optional pagination -->
            <!-- <div class="swiper-pagination"></div> -->
          </div>
          <!-- </div> -->


          <!-- HERO SECTION WITH BACKGROUND IMAGE -->
          <div class="col-xl-10 p-0 h-100">
            <div class="kemis-hero-section mt-xl-0 pt-xl-0 mt-0 pt-0" #rightContent>
              <div class="kemis-hero-content mt-xl-0 pt-xl-0 mt-xl-0 pt-xl-0">
                <h2>
                  Revolutionizing Education <br />
                  Management in <span class="kemis-highlight-blue">Kenya</span><br />
                  Through
                  <span class="kemis-highlight-red">Data and Innovation</span>
                </h2>

                <p>
                  Welcome to the Kenya Education Management Information System
                  (KEMIS), your comprehensive platform for education data
                  management. From early childhood development to university
                  excellence, KEMIS provides the insights and tools necessary to
                  drive informed decision-making and enhance learning outcomes
                  across the nation.
                </p>

                <div class="d-flex flex-wrap justify-content-between">
                  <button (click)="GoToInstitution()" class="kemis-hero-btn mb-2 mb-xl-0">
                    Onboard your institution <i class="bi bi-arrow-right"></i>
                  </button>
                  <a href="#" class="kemis-hero-btn mb-2 mb-xl-0" style="background-color: #2980b9">
                    Explore KEMIS <i class="bi bi-arrow-right"></i>
                  </a>
                </div>

                <div class="kemis-contact-card">
                  <h5 class="text-center">Get in Touch With Us</h5>
                  <div class="kemis-row row">
                    <div class="col-md-6">
                      <div class="kemis-contact-item">
                        <i class="bi bi-envelope-fill kemis-contact-icon" style="color: orange"></i>
                        Info@Kemis.go.ke
                      </div>
                      <div class="kemis-contact-item">
                        <i class="bi bi-geo-alt-fill kemis-contact-icon" style="color: red"></i>
                        Jogoo House B, Taifa road Nairobi
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="kemis-contact-item">
                        <i class="bi bi-whatsapp kemis-contact-icon" style="color: green"></i>
                        +254203318581
                      </div>
                      <div class="kemis-contact-item">
                        <i class="bi bi-globe kemis-contact-icon" style="color: blue"></i>
                        www.kemis.go.ke
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </section>

    <!-- <section class="d-none">
      <div class="container-fluid">
        <div class="row g-0 align-items-stretch">
  
  
          <div class="col-xl-2  p-0">
  
            <div class="vertical-slider-container  h-100">
              <div class="vertical-slider">
                <div><img src="../../../assets/images/landing_imgs/slider_1.png" class="img-fluid w-100" alt="Slide 1">
                </div>
                <div><img src="../../../assets/images/landing_imgs/slider_2.png" class="img-fluid w-100" alt="Slide 2">
                </div>
                <div><img src="../../../assets/images/landing_imgs/slider_3.png" class="img-fluid w-100" alt="Slide 3">
                </div>
                <div><img src="../../../assets/images/landing_imgs/slider_1.png" class="img-fluid w-100" alt="Slide 3">
                </div>
              </div>
            </div>
  
          </div>
          <div class="col-xl-10 p-0 h-100">
            <div class="kemis-hero-section">
              <div class="kemis-hero-content">
                <h2>
                  Revolutionizing Education <br> Management in
                  <span class="kemis-highlight-blue">Kenya</span><br>
                  Through <span class="kemis-highlight-red">Data and Innovation</span>
                </h2>
  
                <p>
                  Welcome to the Kenya Education Management Information System (KEMIS), your comprehensive platform for
                  education data management. From early childhood development to university excellence, KEMIS provides the
                  insights and tools necessary to drive informed decision-making and enhance learning outcomes across the
                  nation.
                </p>
  
                <div class="d-flex flex-wrap">
                  <a href="#" class="kemis-hero-btn">
                    Register Your Institution <i class="bi bi-arrow-right"></i>
                  </a>
                  <a href="#" class="kemis-hero-btn" style="background-color: #2980b9;">
                    Explore KEMIS <i class="bi bi-arrow-right"></i>
                  </a>
                </div>
  
                <div class="kemis-contact-card">
                  <h5 class="text-center">Get in Touch With Us</h5>
                  <div class="kemis-row row">
                    <div class="col-md-6">
                      <div class="kemis-contact-item"><i class="bi bi-envelope-fill kemis-contact-icon"></i>
                        Info@Kemis.go.ke</div>
                      <div class="kemis-contact-item"><i class="bi bi-geo-alt-fill kemis-contact-icon"></i> Jogoo House B,
                        Taifa road Nairobi</div>
                    </div>
                    <div class="col-md-6">
                      <div class="kemis-contact-item"><i class="bi bi-whatsapp kemis-contact-icon"></i> +254203318581
                      </div>
                      <div class="kemis-contact-item"><i class="bi bi-globe kemis-contact-icon"></i> www.kemis.go.ke</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </div>
    </section> -->

    <div class="category-style-two-area default-padding bg-cover bg-gray-secondary" style="
        background-image: url('../../../assets/images/landing_imgs/wooden.png');" id="system-module" *ngIf="isShow">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <div class="site-heading text-center">
              <h2 class="title split-text">
                <div class="line" style="display: block; text-align: center; position: relative">
                  <div style="
                      position: relative;
                      display: inline-block;
                      translate: none;
                      rotate: none;
                      scale: none;
                      transform: translate(0px, 0px);
                    ">
                    System
                  </div>
                  <div style="
                      position: relative;
                      display: inline-block;
                      translate: none;
                      rotate: none;
                      scale: none;
                      transform: translate(0px, 0px);
                    ">
                    &nbsp; Modules
                  </div>
                </div>
                <!-- <div class="line" style="display: block; text-align: center; position: relative; ">
                                  <p
                                      style="position: relative; display: inline-block; translate: none; rotate: none; scale: none; transform: translate(0px, 0px); font-size: 14px;">
                                  </p>
                                
                              </div> -->
              </h2>

              <p>
                Discover how KEMIS transforms educational management through
                innovative technology and comprehensive data solutions.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <!-- Swiper -->
            <div class="category-style-two-carousel swiper">
              <div class="swiper-wrapper">
                <!-- Single Slide -->
                <div class="swiper-slide">
                  <div class="category-style-two-item">
                    <a href="course-filter.html">
                      <div class="info">
                        <h4>Institution management</h4>
                        <!-- <span>10 Courses</span> -->
                      </div>
                      <!-- <i class="bi bi-arrow-up-right"></i> -->
                      <div class="thumb">
                        <img src="../../../assets/images/landing_imgs/Institution-management.jpg"
                          alt="Image Not Found" />
                      </div>
                    </a>
                  </div>
                </div>

                <!-- Repeat similar swiper-slide blocks for each category -->
                <div class="swiper-slide">
                  <div class="category-style-two-item">
                    <a href="course-filter.html">
                      <div class="info">
                        <h4>Learner management</h4>
                        <!-- <span>26 Courses</span> -->
                      </div>
                      <!-- <i class="bi bi-arrow-up-right"></i> -->
                      <div class="thumb">
                        <img src="../../../assets/images/landing_imgs/Leaner-management.png" alt="Image Not Found" />
                      </div>
                    </a>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div class="category-style-two-item">
                    <a href="course-filter.html">
                      <div class="info">
                        <h4>Curriculum and academic module</h4>
                        <!-- <span>38 Courses</span> -->
                      </div>
                      <!-- <i class="bi bi-arrow-up-right"></i> -->
                      <div class="thumb">
                        <img src="../../../assets/images/landing_imgs/Curriculum-and-academic-module.png"
                          alt="Image Not Found" />
                      </div>
                    </a>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div class="category-style-two-item">
                    <a href="course-filter.html">
                      <div class="info">
                        <h4>Selection and placement</h4>
                        <!-- <span>20 Courses</span> -->
                      </div>
                      <!-- <i class="bi bi-arrow-up-right"></i> -->
                      <div class="thumb">
                        <img src="../../../assets/images/landing_imgs/Selection-and-placement.png"
                          alt="Image Not Found" />
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="category-style-two-item">
                    <a href="course-filter.html">
                      <div class="info">
                        <h4>Finance and capitation</h4>
                        <!-- <span>20 Courses</span> -->
                      </div>
                      <!-- <i class="bi bi-arrow-up-right"></i> -->
                      <div class="thumb">
                        <img src="../../../assets/images/landing_imgs/Finance-and-capitation.png"
                          alt="Image Not Found" />
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="category-style-two-item">
                    <a href="course-filter.html">
                      <div class="info">
                        <h4>Quality assurance</h4>
                        <!-- <span>20 Courses</span> -->
                      </div>
                      <!-- <i class="bi bi-arrow-up-right"></i> -->
                      <div class="thumb">
                        <img src="../../../assets/images/landing_imgs/Quality-assurance.png" alt="Image Not Found" />
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="category-style-two-item">
                    <a href="course-filter.html">
                      <div class="info">
                        <h4>Staff management</h4>
                        <!-- <span>20 Courses</span> -->
                      </div>
                      <!-- <i class="bi bi-arrow-up-right"></i> -->
                      <div class="thumb">
                        <img src="../../../assets/images/landing_imgs/Staff-management.png" alt="Image Not Found" />
                      </div>
                    </a>
                  </div>
                </div>
                <!-- <div class="swiper-slide">
                  <div class="category-style-two-item">
                    <a href="course-filter.html">
                      <div class="info">
                        <h4>Web Design &amp; <strong>Development</strong></h4>
                        <span>20 Courses</span>
                      </div>
                      <i class="bi bi-arrow-up-right"></i>
                      <div class="thumb">
                        <img src="../../../assets/images/landing_imgs/system-capblity-banner.png" alt="Image Not Found" />
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="category-style-two-item">
                    <a href="course-filter.html">
                      <div class="info">
                        <h4>Web Design &amp; <strong>Development</strong></h4>
                        <span>20 Courses</span>
                      </div>
                      <i class="bi bi-arrow-up-right"></i>
                      <div class="thumb">
                        <img src="../../../assets/images/landing_imgs/system-capblity-banner.png" alt="Image Not Found" />
                      </div>
                    </a>
                  </div>
                </div> -->
              </div>

              <!-- Optional navigation buttons -->
              <!-- <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div> -->

              <!-- Optional pagination -->
              <!-- <div class="swiper-pagination"></div> -->
            </div>
            <div class="swiper-button-next" style="top:65% !important;"> </div>
            <div class="swiper-button-prev" style="top:65% !important;"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="about-style-three-area overflow-hidden default-padding bg-white" *ngIf="isShow">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="about-style-three-items wow fadeInUp" data-wow-delay="200ms" style="
                visibility: visible;
                animation-delay: 200ms;
                animation-name: fadeInUp;
              ">
              <div class="row align-center">
                <div class="col-lg-5">
                  <div class="about-style-three-thumb">
                    <img src="../../../assets/images/landing_imgs/img1.png" alt="Image Not Found" />
                    <img src="../../../assets/images/landing_imgs/eclipse.png" alt="Image Not Found" />
                  </div>
                </div>
                <div class="col-lg-7 pl-60 pl-md-15 pl-xs-15">
                  <div class="about-style-three-info">
                    <h2 class="title split-text">
                      <div class="line" style="
                          display: block;
                          text-align: start;
                          position: relative;
                        ">
                        <div style="
                            position: relative;
                            display: inline-block;
                            translate: none;
                            rotate: none;
                            scale: none;
                            transform: translate(0px, 0px);
                          ">
                          Building
                        </div>
                        <div style="
                            position: relative;
                            display: inline-block;
                            translate: none;
                            rotate: none;
                            scale: none;
                            transform: translate(0px, 0px);
                          ">
                          &nbsp; a Diverse and Equitable
                        </div>

                        <div class="line" style="
                            display: block;
                            text-align: start;
                            position: relative;
                          ">
                          <div style="
                              position: relative;
                              display: inline-block;
                              translate: none;
                              rotate: none;
                              scale: none;
                              transform: translate(0px, 0px);
                            ">
                            &nbsp;Educational
                          </div>
                          <div style="
                              position: relative;
                              display: inline-block;
                              translate: none;
                              rotate: none;
                              scale: none;
                              transform: translate(0px, 0px);
                            ">
                            &nbsp;Ecosystem.
                          </div>
                        </div>
                      </div>
                    </h2>

                    <p>
                      At KEMIS, we are dedicated to promoting diversity, equity,
                      and inclusion across the education sector in Kenya. We
                      recognize that sustainable educational development depends
                      on embracing the unique backgrounds, cultures, and
                      experiences of all learners, educators, and institutions.
                    </p>
                    <div class="fact-style-two">
                      <div class="fun-fact">
                        <div class="counter">
                          <div class="timer" data-to="47" data-speed="2000">
                            47
                          </div>
                          <div class="operator">+</div>
                        </div>
                        <h4>Counties Covered</h4>
                      </div>
                      <div class="fun-fact">
                        <div class="counter">
                          <div class="timer" data-to="40" data-speed="2000">
                            40
                          </div>
                          <div class="operator">K+</div>
                        </div>
                        <h4>Institutions Onboarded</h4>
                      </div>
                      <div class="fun-fact">
                        <div class="counter">
                          <div class="timer" data-to="12" data-speed="2000">
                            12
                          </div>
                          <div class="operator">M+</div>
                        </div>
                        <h4>Learners Managed</h4>
                      </div>
                    </div>
                    <!-- <a class="kemis-hero-btn" href="/institution-reg" style="position: relative; z-index: 99999">Get
                      Started</a> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" *ngIf="isShow">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="site-heading text-center">
            <h2 class="title split-text">
              <div class="line" style="display: block; text-align: center; position: relative">
                <div style="
                    position: relative;
                    display: inline-block;
                    translate: none;
                    rotate: none;
                    scale: none;
                    transform: translate(0px, 0px);
                  ">
                  About Us
                </div>
              </div>
            </h2>
          </div>
        </div>
      </div>
    </div>
    <section id="about-kemis" style="background-image: url('../../../assets/images/landing_imgs/bg.png')"
      *ngIf="isShow">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-12 pt-5 pb-5">
            <div class="container">
              <div class="row">
                <div class="col-xl-12">
                  <div class="slider">
                    <!-- Slide 1 -->
                    <div>
                      <div class="row align-items-center">
                        <div class="col-md-6 mb-md-0">
                          <img src="../../../assets/images/landing_imgs/Empowering-Education-Through-data.png"
                            alt="Slide 1" class="slider-image img-fluid" />
                        </div>
                        <div class="col-md-6 slider-text">
                          <h2 class="text-white">
                            Empowering Education Through Data

                            <!-- Revolutionize how educational data is Collected,
                            Managed, and utilized across all levels of Kenya's
                            Education System. -->
                          </h2>
                          <p class="text-white">
                            KEMIS (Kenya Education Management Information System)
                            is a comprehensive digital platform designed to
                            centralize and streamline education data across Kenya.
                            By integrating data from schools, learners, staff,
                            exams, and administrative modules, KEMIS empowers
                            educators and policymakers with real-time insights to
                            make informed decisions. Our goal is to improve
                            educational outcomes through accurate data management
                            and innovative analytics.
                          </p>
                          <!-- <a href="#" class="kemis-hero-btn">Explore More</a> -->
                        </div>
                      </div>
                    </div>

                    <!-- Slide 2 -->
                    <div>
                      <div class="row align-items-center">
                        <div class="col-md-6 mb-md-0">
                          <img src="../../../assets/images/landing_imgs/Quality-assurance.png" alt="Slide 1"
                            class="slider-image img-fluid" />
                        </div>
                        <div class="col-md-6 slider-text">
                          <h2 class="text-white">
                            Connecting Stakeholders for Better Outcomes
                            <!-- Revolutionize how educational data is Collected,
                            Managed, and utilized across all levels of Kenya's
                            Education System. -->
                          </h2>
                          <p class="text-white">
                            <!-- Discover how KEMIS transforms educational management
                            through innovative technology and comprehensive data
                            solutions. -->
                            KEMIS acts as the backbone of Kenya’s education
                            ecosystem, providing seamless data exchange between
                            schools, government agencies, and education partners.
                            With secure access and powerful reporting tools, KEMIS
                            ensures that every stakeholder, from school
                            administrators to national policymakers, can
                            collaborate effectively to enhance learning
                            experiences and resource allocation across the
                            country.
                          </p>
                          <!-- <a href="#" class="kemis-hero-btn">Explore More</a> -->
                        </div>
                      </div>
                    </div>

                    <!-- Slide 3 -->
                    <div>
                      <div class="row align-items-center">
                        <div class="col-md-6 mb-md-0">
                          <img src="../../../assets/images/landing_imgs/Driving-Evidence-Based-Education-Policy.png"
                            alt="Slide 1" class="slider-image img-fluid" />
                        </div>
                        <div class="col-md-6 slider-text">
                          <h2 class="text-white">
                            <!-- Revolutionize how educational data is Collected,
                            Managed, and utilized across all levels of Kenya's
                            Education System. -->
                            Driving Evidence-Based Education Policy
                          </h2>
                          <p class="text-white">
                            At KEMIS, we believe that data is key to transforming
                            education. Our system supports robust data governance,
                            quality assurance, and advanced analytics, enabling
                            continuous monitoring and evaluation of education
                            programs. By providing comprehensive dashboards and
                            predictive insights, KEMIS helps shape effective
                            education policies that ensure no learner is left
                            behind.
                          </p>
                          <!-- <a href="#" class="kemis-hero-btn">Explore More</a> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="slider-counter" class="me-3 text-white fw-bold text-end">
              01/02
            </div>
            <!-- <div class="slider-controls d-flex align-items-center justify-content-end mt-3 pe-4">
    
              <button class="slick-prev custom-arrow btn btn-outline-info me-2">‹</button>
              <button class="slick-next custom-arrow btn btn-outline-info">›</button>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <div class="blog-area home-blog-style-two bg-gray-gradient-secondary default-padding bottom-less" id="support"
      *ngIf="isShow">
      <div class="container">
        <div class="row">
          <div class="col-xl-12 text-center">
            <h2 class="title split-text mb-0 text-center">
              <div class="line" style="display: block; text-align: center; position: relative">
                <div style="
                    position: relative;
                    display: inline-block;
                    translate: none;
                    rotate: none;
                    scale: none;
                    transform: translate(0px, 0px);
                  ">
                  Support &
                </div>
                <div style="
                    position: relative;
                    display: inline-block;
                    translate: none;
                    rotate: none;
                    scale: none;
                    transform: translate(0px, 0px);
                  ">
                  Training
                </div>
              </div>
            </h2>

            <p>
              Comprehensive support services to ensure successful implementation
              and optimal use of KEMIS across your institution.
            </p>
          </div>
          <!-- Single Item -->
          <div class="col-xl-4 col-md-6 col-lg-6 mb-30 mb-2">
            <div class="home-blog-style-two-item wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
              <div class="thumb">
                <img src="../../../assets/images/landing_imgs/Training-Programs.png" alt="Image not Found" />
                <!-- <ul class="blog-meta">
                  <li><i class="bi bi-calendar-check"></i>October 18, 2025</li>
                </ul> -->
              </div>
              <div class="info">
                <h3 class="blog-title">
                  <a href="#" (click)="isShow=false">Training Videos</a>
                </h3>
                <p>
                  Step-by-step guides to effectively use KEMIS features and modules.
                </p>
                <a href="#"  (click)="isShow=false" class="btn-read-more">Read More <i class="bi bi-arrow-right"></i></a>
              </div>
            </div>
          </div>
          <!-- End Single Item -->
          <!-- Single Item -->
          <div class="col-xl-4 col-md-6 col-lg-6 mb-30 mb-2">
            <div class="home-blog-style-two-item wow fadeInUp" data-wow-delay="200ms" style="
                visibility: visible;
                animation-delay: 200ms;
                animation-name: fadeInUp;
              ">
              <div class="thumb">
                <img src="../../../assets/images/landing_imgs/Helpdesk-Tile.png" alt="Image not Found" />
                <!-- <ul class="blog-meta">
                  <li><i class="bi bi-calendar-check"></i>November 15, 2025</li>
                </ul> -->
              </div>
              <div class="info">
                <h3 class="blog-title">
                  <a href="#l">24/7 Help Desk</a>
                </h3>
                <p>
                  Round-the-clock support for immediate technical assistance and issue resolution.
                </p>
                <a href="#" class="btn-read-more">Read More <i class="bi bi-arrow-right"></i></a>
              </div>
            </div>
          </div>
          <!-- End Single Item -->
          <!-- Single Item -->
          <div class="col-xl-4 col-md-6 col-lg-6 mb-30 mb-2">
            <div class="home-blog-style-two-item wow fadeInUp" data-wow-delay="400ms" style="
                visibility: visible;
                animation-delay: 400ms;
                animation-name: fadeInUp;
              ">
              <div class="thumb">
                <img src="../../../assets/images/landing_imgs/Manual-Tile.png" alt="Image not Found" />
                <!-- <ul class="blog-meta">
                  <li><i class="bi bi-calendar-check"></i>December 13, 2025</li>
                </ul> -->
              </div>
              <div class="info">
                <h3 class="blog-title">
                  <a  href="#" (click)="isShow=false">Manuals</a>
                </h3>
                <p>
                  Detailed guides and manuals for easy KEMIS system navigation and troubleshooting.
                </p>
                <a href="#" (click)="isShow=false" class="btn-read-more">Read More <i class="bi bi-arrow-right"></i></a>
              </div>
            </div>
          </div>
          <!-- End Single Item -->
        </div>
      </div>
    </div>

    <div class="blog-area home-blog-style-two bg-gray-gradient-secondary default-padding bottom-less" id="faqs"
      *ngIf="isShow">
      <div class="container">
        <div class="faq-container">

          <h1>KEMIS - Frequently Asked Questions</h1>
        
          <!-- General System Overview -->
          <h2>General System Overview</h2>
        
          <details><summary>1. What is KEMIS?</summary><p>KEMIS (Kenya Education Management Information System) is an integrated national platform designed to manage education data across institutions, learners, staff, and supporting services, enabling efficient planning, monitoring, and service delivery.</p></details>
        
          <details><summary>2. Who will use KEMIS?</summary><p>KEMIS is used by institutions, learners, teachers, school administrators, quality assurance officers, county and national education officials, and other authorized stakeholders.</p></details>
        
          <details><summary>3. Why was KEMIS introduced?</summary><p>KEMIS was introduced to centralize education data, eliminate duplication, improve accountability, and support informed decision-making across the education sector.</p></details>
        
          <!-- Access & Login -->
          <h2>Access & Login</h2>
        
          <details><summary>4. How do users access KEMIS?</summary><p>Users access KEMIS via assigned URLs and credentials based on their role. Access is role-based and restricted to approved permissions.</p></details>
        
          <details><summary>5. How do I create an account on KEMIS?</summary><p>An Institution’s account is created after an institution successfully registers on KEMIS using official institutional details. The registration is reviewed and approved by Ministry of Education officials, after which login credentials are issued via the institution's email provided during registration to authorized officers such as Heads of Institutions and designated school staff.</p></details>
        
          <details><summary>6. What should I do if I forget my password?</summary><p>Use the “Forgot/Reset Password” option on the KEMIS login page and follow the prompts to reset your password using your registered username (institution’s email). If you are unable to reset your password, contact KEMIS through helpdesk@kemis.go.ke</p></details>
        
          <details><summary>7. Does the system allow multiple users per institution?</summary><p>Yes. KEMIS supports multiple authorized users per institution such as Heads of Institutions, deputies, class teachers and school accounts clerks. Each user has unique login credentials.</p></details>
        
          <details><summary>8. Is it possible for multiple users to access the school dashboard simultaneously?</summary><p>Yes. Multiple authorized users from the same institution can access the system simultaneously, provided each user logs in using their own unique account credentials. The system does not allow multiple users to log in using the same account at the same time.</p></details>
        
          <!-- Registration & Learner Data -->
          <h2>Registration & Learner Data</h2>
        
          <details><summary>9. At what stage should the Unique Personal Identifier (UPI) be captured?</summary><p>The Unique Personal Identifier is generated during learner registration or when updating an existing learner record.</p></details>
        
          <details><summary>10. Which number from the birth certificate should be entered - the serial number or the entry number?</summary><p>Schools should enter the official birth certificate entry number and not the printing or internal serial number on the document.</p></details>
        
          <details><summary>11. Will all schools undergo a new registration process on the system?</summary><p>All schools are required to register onto KEMIS afresh.</p></details>
        
          <details><summary>12. What specific reports or information must be submitted during school registration?</summary><p>None. Specific reports shall be generated based on the data entered in the institution modules.</p></details>
        
          <details><summary>13. Can the system prevent Heads of Institutions from adding non-existent learners?</summary><p>Yes. KEMIS is designed to eliminate non-existent learners by use of unique identifiers.</p></details>
        
          <details><summary>14. How do I update learner details when they change schools?</summary><p>A learner’s details can be edited by the Head of the institution.</p></details>
        
          <details><summary>15. How will learners without an assessment number be registered?</summary><p>They will be registered using the KNEC index number (where applicable).</p></details>
        
          <!-- System Functionality -->
          <h2>System Functionality</h2>
        
          <details><summary>16. Are there audit trails to track changes made by users?</summary><p>Yes. KEMIS has comprehensive audit trails that log user activities.</p></details>
        
          <!-- System Readiness & Performance -->
          <h2>System Readiness & Performance</h2>
        
          <details><summary>17. What browsers are supported by KEMIS?</summary><p>KEMIS supports modern browsers such as Chrome, Edge, and Firefox for optimal performance.</p></details>
        
          <details><summary>18. What happens if the system is slow or unavailable?</summary><p>System availability is monitored continuously. Any downtime or performance issues should be reported through the helpdesk for immediate escalation and resolution.</p></details>
        
          <!-- Training & Rollout -->
          <h2>Training & Rollout</h2>
        
          <details><summary>19. How will users be trained on KEMIS?</summary><p>Training is conducted through a Training of Trainers (ToT) approach, followed by institution-level training using approved manuals, system demonstrations, and practical sessions.</p></details>
        
          <details><summary>20. Will there be training materials available?</summary><p>Yes. Training manuals, user guides, and reference materials will be provided for all user categories.</p></details>
        
          <details><summary>21. Will there be dry runs before go-live?</summary><p>Yes. System testing and dry runs are conducted to validate workflows and ensure readiness before rollout.</p></details>
        
          <!-- Data & Reporting -->
          <h2>Data & Reporting</h2>
        
          <details><summary>22. How is data accuracy ensured in KEMIS?</summary><p>Data validation rules, approval workflows, and role-based verification processes are built into the system to ensure accuracy and integrity.</p></details>
        
          <details><summary>23. Can reports be generated from KEMIS?</summary><p>Yes. KEMIS provides standard reports and allows generation of role-specific reports to support decision-making and compliance.</p></details>
        
          <details><summary>24. Who is responsible for validating submitted data?</summary><p>Data validation is performed at different levels depending on the workflow, including institution administrators and relevant education authorities.</p></details>
        
          <!-- Infrastructure & Support -->
          <h2>Infrastructure & Support</h2>
        
          <details><summary>25. How is system security handled?</summary><p>KEMIS uses secure authentication, access control, and audit logs to protect system data and ensure accountability.</p></details>
        
          <details><summary>26. Is there a helpdesk for KEMIS?</summary><p>Yes. A dedicated helpdesk is available to support users with technical issues, system access, and operational queries.</p></details>
        
          <details><summary>27. How are system updates communicated?</summary><p>Updates, changes, and system notices are communicated through official channels prior to implementation.</p></details>
        
          <!-- Go-Live & Post-Rollout -->
          <h2>Go-Live & Post-Rollout</h2>
        
          <details><summary>28. What support is available after rollout?</summary><p>Post-rollout support includes helpdesk assistance, continuous monitoring, issue resolution, and periodic system enhancements.</p></details>
        
          <details><summary>29. Can feedback be submitted after rollout?</summary><p>Yes. User feedback is encouraged and will be reviewed to support system improvements and optimization.</p></details>
        
          <!-- Compliance & Accountability -->
          <h2>Compliance & Accountability</h2>
        
          <details><summary>30. Is KEMIS mandatory for institutions?</summary><p>Yes. KEMIS is the official system for education data management and compliance as directed by the Ministry.</p></details>
        
          <details><summary>31. What happens if institutions do not comply?</summary><p>Non-compliance may affect reporting, approvals, and access to education services tied to system usage.</p></details>
        
          <details><summary>32. Are institutions audited for system usage?</summary><p>Yes. Compliance audits may be conducted by the Ministry of Education.</p></details>
        
          <details><summary>33. How can institutions raise concerns or suggestions?</summary><p>Institutions can raise concerns or suggestions through official support and helpdesk channels.</p></details>
        
        </div>
        
      </div>
    </div>

    <div class="testimonial-style-two-area default-padding bg-white d-none" *ngIf="isShow">
      <div class="container">
        <div class="row">
          <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
            <div class="site-heading text-center">
              <h2 class="title split-text">
                <div class="line" style="display: block; text-align: center; position: relative">
                  <div style="
                      position: relative;
                      display: inline-block;
                      translate: none;
                      rotate: none;
                      scale: none;
                      transform: translate(0px, 0px);
                    ">
                    Best review
                  </div>
                  <div style="
                      position: relative;
                      display: inline-block;
                      translate: none;
                      rotate: none;
                      scale: none;
                      transform: translate(0px, 0px);
                    ">
                    &nbsp; from our
                  </div>
                  <div style="
                      position: relative;
                      display: inline-block;
                      translate: none;
                      rotate: none;
                      scale: none;
                      transform: translate(0px, 0px);
                    ">
                    successful students
                  </div>
                </div>
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid d-none">
        <div class="row">
          <div class="col-lg-12">
            <div class="testimonial-style-two-carousel swiper">
              <div class="swiper-wrapper">
                <!-- Slide 1 -->
                <div class="swiper-slide">
                  <div class="testimonial-style-two">
                    <div class="top-info">
                      <div class="icon">
                        <img src="../../../assets/images/landing_imgs/quote.png" alt="Image Not Found" />
                      </div>
                      <h5>Best Course Ever</h5>
                    </div>
                    <div class="content">
                      <p>
                        Education is the most powerful tool to change the world...
                      </p>
                      <div class="bottom-info">
                        <div class="provider">
                          <div class="thumb">
                            <img src="../../../assets/images/landing_imgs/student.png" alt="Image Not Found" />
                          </div>
                          <div class="info">
                            <h4>Kennsual Martin</h4>
                            <span>Laravel Batch - 11</span>
                          </div>
                        </div>
                        <div class="provider">
                          <div class="ratings">
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Slide 2 -->
                <div class="swiper-slide">
                  <div class="testimonial-style-two">
                    <div class="top-info">
                      <div class="icon">
                        <img src="../../../assets/images/landing_imgs/quote.png" alt="Image Not Found" />
                      </div>
                      <h5>Very Easy Course</h5>
                    </div>
                    <div class="content">
                      <p>
                        Education is the most powerful tool to change the world...
                      </p>
                      <div class="bottom-info">
                        <div class="provider">
                          <div class="thumb">
                            <img src="../../../assets/images/landing_imgs/student.png" alt="Image Not Found" />
                          </div>
                          <div class="info">
                            <h4>Amanulla Joey</h4>
                            <span>React Batch - 28</span>
                          </div>
                        </div>
                        <div class="provider">
                          <div class="ratings">
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill-half-alt"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Slide 3 -->
                <div class="swiper-slide">
                  <div class="testimonial-style-two">
                    <div class="top-info">
                      <div class="icon">
                        <img src="../../../assets/images/landing_imgs/quote.png" alt="Image Not Found" />
                      </div>
                      <h5>Excellent Quality</h5>
                    </div>
                    <div class="content">
                      <p>
                        Learning is the most powerful tool to change the world...
                      </p>
                      <div class="bottom-info">
                        <div class="provider">
                          <div class="thumb">
                            <img src="../../../assets/images/landing_imgs/student.png" alt="Image Not Found" />
                          </div>
                          <div class="info">
                            <h4>Kamal Abraham</h4>
                            <span>PHP Course</span>
                          </div>
                        </div>
                        <div class="provider">
                          <div class="ratings">
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Slide 4 -->
                <div class="swiper-slide">
                  <div class="testimonial-style-two">
                    <div class="top-info">
                      <div class="icon">
                        <img src="../../../assets/images/landing_imgs/quote.png" alt="Image Not Found" />
                      </div>
                      <h5>Great Quality</h5>
                    </div>
                    <div class="content">
                      <p>A mind is a terrible thing to waste of perfection...</p>
                      <div class="bottom-info">
                        <div class="provider">
                          <div class="thumb">
                            <img src="../../../assets/images/landing_imgs/student.png" alt="Image Not Found" />
                          </div>
                          <div class="info">
                            <h4>Michel Dark</h4>
                            <span>WordPress Course</span>
                          </div>
                        </div>
                        <div class="provider">
                          <div class="ratings">
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill-half-alt"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Slide 4 -->
                <div class="swiper-slide">
                  <div class="testimonial-style-two">
                    <div class="top-info">
                      <div class="icon">
                        <img src="../../../assets/images/landing_imgs/quote.png" alt="Image Not Found" />
                      </div>
                      <h5>Great Quality</h5>
                    </div>
                    <div class="content">
                      <p>A mind is a terrible thing to waste of perfection...</p>
                      <div class="bottom-info">
                        <div class="provider">
                          <div class="thumb">
                            <img src="../../../assets/images/landing_imgs/student.png" alt="Image Not Found" />
                          </div>
                          <div class="info">
                            <h4>Michel Dark</h4>
                            <span>WordPress Course</span>
                          </div>
                        </div>
                        <div class="provider">
                          <div class="ratings">
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill-half-alt"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Slide 4 -->
                <div class="swiper-slide">
                  <div class="testimonial-style-two">
                    <div class="top-info">
                      <div class="icon">
                        <img src="../../../assets/images/landing_imgs/quote.png" alt="Image Not Found" />
                      </div>
                      <h5>Great Quality</h5>
                    </div>
                    <div class="content">
                      <p>A mind is a terrible thing to waste of perfection...</p>
                      <div class="bottom-info">
                        <div class="provider">
                          <div class="thumb">
                            <img src="../../../assets/images/landing_imgs/student.png" alt="Image Not Found" />
                          </div>
                          <div class="info">
                            <h4>Michel Dark</h4>
                            <span>WordPress Course</span>
                          </div>
                        </div>
                        <div class="provider">
                          <div class="ratings">
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill-half-alt"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Slide 4 -->
                <div class="swiper-slide">
                  <div class="testimonial-style-two">
                    <div class="top-info">
                      <div class="icon">
                        <img src="../../../assets/images/landing_imgs/quote.png" alt="Image Not Found" />
                      </div>
                      <h5>Great Quality</h5>
                    </div>
                    <div class="content">
                      <p>A mind is a terrible thing to waste of perfection...</p>
                      <div class="bottom-info">
                        <div class="provider">
                          <div class="thumb">
                            <img src="../../../assets/images/landing_imgs/student.png" alt="Image Not Found" />
                          </div>
                          <div class="info">
                            <h4>Michel Dark</h4>
                            <span>WordPress Course</span>
                          </div>
                        </div>
                        <div class="provider">
                          <div class="ratings">
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill-half-alt"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Slide 4 -->
                <div class="swiper-slide">
                  <div class="testimonial-style-two">
                    <div class="top-info">
                      <div class="icon">
                        <img src="../../../assets/images/landing_imgs/quote.png" alt="Image Not Found" />
                      </div>
                      <h5>Great Quality</h5>
                    </div>
                    <div class="content">
                      <p>A mind is a terrible thing to waste of perfection...</p>
                      <div class="bottom-info">
                        <div class="provider">
                          <div class="thumb">
                            <img src="../../../assets/images/landing_imgs/student.png" alt="Image Not Found" />
                          </div>
                          <div class="info">
                            <h4>Michel Dark</h4>
                            <span>WordPress Course</span>
                          </div>
                        </div>
                        <div class="provider">
                          <div class="ratings">
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill"></i>
                            <i class="bi bi-star-fill-half-alt"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Optional navigation or pagination -->
              <!-- <div class="swiper-pagination"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="newsletter-area default-padding-bottom bg-gray-gradient-secondary pt-5 pb-5" *ngIf="false">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="newsletter-style-one-items bg-theme text-center bg-cover" style="
                background-image: url('../../../assets/images/landing_imgs/banner-8.jpg');
              ">
              <div class="shape">
                <!-- <img src="assets/img/illustration/" alt="Image Not Found"> -->
                <img src="../../../assets/images/landing_imgs/sub.png" class="img-fluid" alt="Image Not Found" />
              </div>
              <div class="row">
                <div class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
                  <h2 class="title split-text">
                    <div class="line" style="
                        display: block;
                        text-align: center;
                        position: relative;
                      ">
                      <div style="
                          position: relative;
                          display: inline-block;
                          translate: none;
                          rotate: none;
                          scale: none;
                          transform: translate(0px, 0px);
                        ">
                        Subscribe
                      </div>
                      <div style="
                          position: relative;
                          display: inline-block;
                          translate: none;
                          rotate: none;
                          scale: none;
                          transform: translate(0px, 0px);
                        ">
                        to
                      </div>
                      <div style="
                          position: relative;
                          display: inline-block;
                          translate: none;
                          rotate: none;
                          scale: none;
                          transform: translate(0px, 0px);
                        ">
                        our
                      </div>
                      <div style="
                          position: relative;
                          display: inline-block;
                          translate: none;
                          rotate: none;
                          scale: none;
                          transform: translate(0px, 0px);
                        ">
                        newsletter,
                      </div>
                    </div>
                    <div class="line" style="
                        display: block;
                        text-align: center;
                        position: relative;
                      ">
                      <div style="
                          position: relative;
                          display: inline-block;
                          translate: none;
                          rotate: none;
                          scale: none;
                          transform: translate(0px, 0px);
                        ">
                        We
                      </div>
                      <div style="
                          position: relative;
                          display: inline-block;
                          translate: none;
                          rotate: none;
                          scale: none;
                          transform: translate(0px, 0px);
                        ">
                        don't
                      </div>
                      <div style="
                          position: relative;
                          display: inline-block;
                          translate: none;
                          rotate: none;
                          scale: none;
                          transform: translate(0px, 0px);
                        ">
                        make
                      </div>
                      <div style="
                          position: relative;
                          display: inline-block;
                          translate: none;
                          rotate: none;
                          scale: none;
                          transform: translate(0px, 0px);
                        ">
                        any
                      </div>
                      <div style="
                          position: relative;
                          display: inline-block;
                          translate: none;
                          rotate: none;
                          scale: none;
                          transform: translate(0px, 0px);
                        ">
                        spam.
                      </div>
                    </div>
                  </h2>
                  <ul class="list-check">
                    <li>Easy to Access</li>
                    <li>No Credit card</li>
                    <li>10M student onboard with us</li>
                  </ul>
                  <form action="#">
                    <input type="email" placeholder="Your Email" class="form-control" name="email" />
                    <button type="submit">Subscribe</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section *ngIf="!isShow">



      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-12">

            <div class="card">
              <div class="card-body bg-secondary">
                <h4 class="text-white">Downloads</h4>

              </div>
            </div>
          </div>
          <div class="col-xl-10 mx-auto">
            <div class="card">
              <div class="card-body mb-1 mt-1">
                <div class="pt-2 table-responsive">
                  <table datatable id="DataTables_Table_0" class="table-striped table-bordered mt-2 pt-2 table-sm small"
                    style="width: 100%">
                    <!-- <thead>
                    <tr>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead> -->
                    <tbody>
                      <!-- <tr *ngFor="let item of resourceLst">
                      <td></td>
                      <td>
                        <button class="btn btn-primary btn-sm"></button>
                      </td>
                    </tr> -->
                      <!-- <tr>
                        <td>2025 - 2026 Fees Structure</td>
                        <td>
                          <button class="btn btn-sm kemis-hero-btn px-2 py-1 rounded-0">View</button>
                        </td>
                      </tr> -->
                      <!-- <tr>
                        <td>Faculity and Postgraduate Publication Spotlights</td>
                        <td>
                          <button class="btn btn-sm kemis-hero-btn px-2 py-1 rounded-0">Download</button>
                        </td>
                      </tr> -->
                      <!-- <tr>
                        <td>HELB New Funding Model</td>
                        <td>
                          <button class="btn btn-sm kemis-hero-btn px-2 py-1 rounded-0">Download</button>
                        </td>
                      </tr> -->
                      <tr>
                        <td>Institution Registration User Guide</td>
                        <td>
                          <button class="btn btn-sm kemis-hero-btn px-2 py-1 rounded-0" (click)="openUserGuide()">View</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>











      <div class="card d-none">
        <div class="card-body p-2">
          <div class="row">
            <div class="pt-2 table-responsive">
              <table class="table-striped table-bordered mt-2 pt-2 table-sm small" style="width: 100%">
                <thead class="top">
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2025 - 2026 Fees Structure</td>
                    <td>
                      <button class="btn btn-primary btn-sm">View</button>
                    </td>
                  </tr>
                  <tr>
                    <td>Faculity and Postgraduate Publication Spotlights</td>
                    <td>
                      <button class="btn btn-primary btn-sm">Download</button>
                    </td>
                  </tr>
                  <tr>
                    <td>HELB New Funding Model</td>
                    <td>
                      <button class="btn btn-primary btn-sm">Download</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer class="bg-dark footer-style-one text-light">
      <!-- <div class="footer-shape-style-one">
              <img src="assets/img/shape/2-light.png" alt="Image Not Found">
          </div> -->
      <div class="container">
        <div class="f-items default-padding">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="mb-3">
                <img src="../../../assets/images/landing_imgs/Kemis-Logo.png" alt="KEMIS Logo"
                  style="max-width: 180px" />
              </div>
              <p>
                Empowering Kenya's education through innovative technology and
                comprehensive data management solutions.
              </p>
              <!-- Social Icons -->
              <div class="d-flex gap-3 mt-3">
                <a href="#" class="text-light fs-5"><i class="bi bi-facebook"></i></a>

                <a href="#" class="text-light fs-5"><i class="bi bi-youtube"></i></a>
                <a href="#" class="text-light fs-5"><i class="bi bi-linkedin"></i></a>
              </div>
            </div>

            <div class="col-lg-2 col-md-6 footer-item">
              <div class="f-item link">
                <h4 class="widget-title">Quick Link</h4>
                <ul>
                  <li>
                    <a (click)="GoToLogin()" class="text-light text-decoration-none">Login to KEMIS</a>
                  </li>
                  <li>
                    <a (click)="GoToInstitution()" class="text-light text-decoration-none">Register Institution</a>
                  </li>
                  <li>
                    <a (click)="openUploadModal()" class="text-light text-decoration-none">KEMIS Resources</a>
                  </li>
                  <li>
                    <a href="#support" class="text-light text-decoration-none">Support</a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-2 col-md-6 footer-item" *ngIf="false">
              <div class="f-item link">
                <h4 class="widget-title">Career</h4>
                <ul>
                  <li>
                    <a href="#" class="text-light text-decoration-none">System Dashboard</a>
                  </li>
                  <li>
                    <a href="#" class="text-light text-decoration-none">Training Resources</a>
                  </li>
                  <li>
                    <a href="#" class="text-light text-decoration-none">Data Submission Portal</a>
                  </li>
                  <li>
                    <a href="#" class="text-light text-decoration-none">User Management</a>
                  </li>
                  <li>
                    <a href="#" class="text-light text-decoration-none">System Status</a>
                  </li>
                  <li>
                    <a href="#" class="text-light text-decoration-none">Tenders</a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-2 col-md-6 footer-item">
              <div class="f-item link">
                <h4 class="widget-title">Help</h4>
                <ul>
                  <li>
                    <a href="#faqs" class="text-light text-decoration-none">FAQ</a>
                  </li>
                  <li>
                    <a href="#" class="text-light text-decoration-none">Sitemap</a>
                  </li>
                  <li>
                    <a href="#support" class="text-light text-decoration-none">Support</a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 footer-item">
              <div class="f-item newsletter">
                <h4 class="widget-title">Location</h4>
                <address>
                  Ministry of Education<br />
                  Jogoo House B, Harambee Ave<br />
                  P.O. Box 30040-00100<br />
                  Nairobi, Kenya<br /><br />
                  <a href="tel:+25420318476" class="text-light text-decoration-none d-block">
                    <i class="bi bi-telephone"></i> +254 203318581
                  </a>
                  <a href="mailto:support@kemis.go.ke" class="text-light text-decoration-none">
                    <i class="bi bi-envelope"></i> support@kemis.go.ke
                  </a>
                </address>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Start Footer Bottom -->
      <div class="footer-bottom style-one">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <p class="mb-0">
                &copy; Copyright 2026 - All rights reserved - KEMIS
              </p>
            </div>
            <div class="col-lg-6 text-end d-none">
              <ul class="link-list">
                <li class="list-inline-item">
                  <a href="#" class="text-light text-decoration-none">Terms</a>
                </li>
                <li class="list-inline-item">
                  <a href="#" class="text-light text-decoration-none">Privacy</a>
                </li>
                <li class="list-inline-item">
                  <a href="#support" class="text-light text-decoration-none">Support</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- End Footer Bottom -->
    </footer>
  </div>
</div>